export default "__VITE_ASSET__Ylh6O5AG__"